import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetPersonStyle0 = gravityIconIndividualCss;

const GravityIconAssetPerson = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4686beacb378e313010122f50b9003484c6d2b56', color: this.color, size: this.size }, h("svg", { key: 'efa874d24c2e470ea363232e1cb6c8851dbaf22a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '0edfa3d4b89776a9cdf2dd2a39e1dfe5d120942b', d: "M7.55 10.152a2.85 2.85 0 0 0 2.91 2.68 2.85 2.85 0 0 0 2.92-2.68l.29-2.55a3 3 0 0 0-3.21-3.59 3 3 0 0 0-3.21 3.59l.3 2.55Zm5.999 7.778a.374.374 0 0 1-.187.07c-.136 0-.183-.113-.129-.31l.627-2.163-1.716-1.513c-.105-.09-.144-.151-.144-.23 0-.108.082-.159.284-.178l2.14-.195.864-2.185c.062-.16.125-.226.214-.226.09 0 .148.062.214.226l.864 2.185 2.136.194c.202.02.284.07.284.18 0 .077-.039.14-.144.229l-1.712 1.513.626 2.162c.059.195.012.311-.128.311a.385.385 0 0 1-.187-.07l-1.953-1.28-1.953 1.28Zm-3.089-3.098c.165-.001 1 .07 1 .57l-.002.13c-.008.683-.016 1.391-.298 1.72a.49.49 0 0 1-.35.15H4.5a.5.5 0 0 1-.49-.6 4.58 4.58 0 0 1 2.63-3.28.5.5 0 0 1 .56.09 4.83 4.83 0 0 0 3.26 1.22Z", fill: "currentColor" }))));
    }
};
GravityIconAssetPerson.style = GravityIconAssetPersonStyle0;

export { GravityIconAssetPerson as gravity_icon_asset_person };

//# sourceMappingURL=gravity-icon-asset-person.entry.js.map